import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({ selector: '[ifCssSupport]' })
export class IfCssSupportDirective {

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) {}

  @Input()
  set ifCssSupport(property: string) {
    const isInverse = property[0] == '!';
    if (isInverse) property = property.slice(1);

    if (!isInverse) {
      if (property in document.body.style) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    } else {
      if (property in document.body.style) {
        this.viewContainer.clear();
      } else {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    }
  }
}
